CLASSIC_FACET_FITNESS_LEVEL